import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=3a3a6d08&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3a6d08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a3a6d08')) {
      api.createRecord('3a3a6d08', component.options)
    } else {
      api.reload('3a3a6d08', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=3a3a6d08&scoped=true", function () {
      api.rerender('3a3a6d08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/vocational-evaluation/tabs/ten/Main.vue"
export default component.exports